import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { JobPosition } from '@treams/treams-network';
import { Button, ContextMenu } from '@treams/treams-ui';

import { useJobTitleName } from '../job/useJobTitleName';
import { useModalLink } from './ModalNavigation';

const StyledButton = styled(Button)<{ isLast?: boolean }>`
	margin-bottom: ${({ isLast }) => (isLast ? 0 : '8px')};
`;

type Props = {
	userID: string;
	jobPosition: JobPosition;
	isLast?: boolean;
	isDropdown?: boolean;
};

const JobPositionButton: FC<Props> = ({ jobPosition, isLast, isDropdown }) => {
	const link = useModalLink(`/job-positions/${jobPosition?.id}`);
	const jobTitleName = useJobTitleName();

	if (isDropdown) {
		return (
			<Link to={link}>
				<ContextMenu.Item title={jobTitleName(jobPosition?.jobTitle)} />
			</Link>
		);
	}

	return (
		<StyledButton
			link={link}
			title={jobTitleName(jobPosition?.jobTitle)}
			type="plain"
			small
			textAlign="center"
			isLast={isLast}
		/>
	);
};

export default JobPositionButton;
